import React, { useEffect } from 'react';
import { CModal, CModalBody, CCarousel, CCarouselItem, CModalHeader } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';

const ShowImage = ({ show, onClose, imgList, imageActive }) => {
     const setActionVideo = () => {
          setTimeout(() => {
               const listCarouselItem = document.querySelectorAll('.carousel-item');
               for (const item of listCarouselItem) {
                    if (item.classList.contains('active')) {
                         if (item.querySelector('video')) {
                              item.querySelector('video').play();
                         }
                    } else if (item.querySelector('video')) {
                         item.querySelector('video').pause();
                    }
               }
          }, 100);
     };

     useEffect(() => {
          setActionVideo();
     }, []);

     return (
          <div className='attachments-popup'>
               <CModal className='image-ticket' size='lg' visible={show} alignment='center' portal={false} onClose={onClose}>
                    <CModalHeader closeButton={false}>
                         <CIcon icon='cil-x' onClick={onClose} className='icon-close-popup'></CIcon>
                    </CModalHeader>
                    <CModalBody className='text-center'>
                         <div className='slider-box'>
                              <CCarousel interval={false} controls={imgList.length > 1} transition='crossfade' activeIndex={imageActive}>
                                   {imgList.map((data, index) => {
                                        if (data.type.includes('video')) {
                                             return (
                                                  <CCarouselItem key={index}>
                                                       <video className='d-block' controls>
                                                            <source src={data.url} type={data.type} />
                                                            <track kind="captions" />
                                                       </video>
                                                  </CCarouselItem>
                                             );
                                        } else {
                                             return (
                                                  <CCarouselItem key={index}>
                                                       <img className='d-block' src={data.url} alt={data.url} />
                                                  </CCarouselItem>
                                             );
                                        }
                                   })}
                              </CCarousel>
                         </div>
                    </CModalBody>
               </CModal>
          </div>
     );
};

ShowImage.propTypes = {
     show: PropTypes.bool,
     onClose: PropTypes.func,
     loading: PropTypes.bool,
     imageActive: PropTypes.any,
     imgList: PropTypes.array,
};

export default ShowImage;
